
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[rewrite_url]",
      function () {
        return require("private-next-pages/product/[rewrite_url].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[rewrite_url]"])
      });
    }
  